
import { defineComponent, PropType } from 'vue'
import { IBreadcrumb } from '../types/index'
export default defineComponent({
  name: 'breadcrumb',
  props: {
    breadcrumb: {
      type: Array as PropType<IBreadcrumb[]>,
      default: () => []
    }
  },
  setup() {
    return {}
  },
  components: {}
})
